export const APP_NAME = "Aegis";

export const NAV_ITEMS = {
  public: [
    { label: "How it works", href: "/how-it-works" },
    { label: "Individuals", href: "/individuals" },
    { label: "Institutions", href: "/institutions" },
    { label: "Pricing", href: "/pricing" },
    { label: "About", href: "/about" },
    { label: "Trust", href: "/trust" },
  ],
  app: [
    { label: "Dashboard", href: "/app", icon: "LayoutDashboard" },
    { label: "Assets", href: "/app/assets", icon: "Briefcase" },
    { label: "Roles", href: "/app/roles", icon: "Users" },
    { label: "Guardians & Trustees", href: "/app/guardians", icon: "Shield" },
    { label: "Digital Custody", href: "/app/digital-custody", icon: "Wallet" },
    { label: "Healthcare", href: "/app/healthcare", icon: "Heart" },
    { label: "Notarization", href: "/app/notarization", icon: "Stamp" },
    { label: "Beneficiary", href: "/app/beneficiary", icon: "Gift" },
    { label: "Triggers", href: "/app/triggers", icon: "Bell" },
    { label: "Instructions", href: "/app/instructions", icon: "FileText" },
    { label: "Activity", href: "/app/activity", icon: "Activity" },
  ],
  partner: [
    { label: "Overview", href: "/partner", icon: "LayoutDashboard" },
    { label: "Cases", href: "/partner/cases", icon: "FolderOpen" },
    { label: "Audits", href: "/partner/audits", icon: "ClipboardCheck" },
    { label: "API Keys", href: "/partner/api-keys", icon: "Key" },
    { label: "Webhooks", href: "/partner/webhooks", icon: "Plug" },
    { label: "Users", href: "/partner/users", icon: "Users" },
    { label: "Jurisdictions", href: "/partner/jurisdictions", icon: "Globe" },
    { label: "Escalations", href: "/partner/escalations", icon: "AlertTriangle" },
    { label: "Billing", href: "/partner/billing", icon: "CreditCard" },
    { label: "Incidents", href: "/partner/incidents", icon: "AlertOctagon" },
    { label: "Documentation", href: "/partner/docs", icon: "BookOpen" },
    // Elevated Services
    { label: "Guardians & Trustees", href: "/partner/guardians", icon: "Shield" },
    { label: "Digital Custody", href: "/partner/digital-custody", icon: "Wallet" },
    { label: "Healthcare", href: "/partner/healthcare", icon: "Heart" },
    { label: "Notarization", href: "/partner/notarization", icon: "Stamp" },
    { label: "Beneficiary", href: "/partner/beneficiary", icon: "Gift" },
  ],
  enterprise: [
    { label: "Organizations", href: "/enterprise", icon: "Building2" },
    { label: "Members", href: "/enterprise/members", icon: "Users" },
    { label: "Teams", href: "/enterprise/teams", icon: "UsersRound" },
    { label: "SSO & SAML", href: "/enterprise/sso", icon: "ShieldCheck" },
    { label: "White Label", href: "/enterprise/branding", icon: "Palette" },
    { label: "Audit Log", href: "/enterprise/audits", icon: "ClipboardCheck" },
    { label: "Settings", href: "/enterprise/settings", icon: "Settings" },
    // Elevated Services
    { label: "Guardians & Trustees", href: "/enterprise/guardians", icon: "Shield" },
    { label: "Digital Custody", href: "/enterprise/digital-custody", icon: "Wallet" },
    { label: "Healthcare", href: "/enterprise/healthcare", icon: "Heart" },
    { label: "Notarization", href: "/enterprise/notarization", icon: "Stamp" },
    { label: "Beneficiary", href: "/enterprise/beneficiary", icon: "Gift" },
  ],
  admin: [
    { label: "Overview", href: "/admin", icon: "LayoutDashboard" },
    { label: "Analytics", href: "/admin/analytics", icon: "BarChart3" },
    { label: "Feedback & Insights", href: "/admin/feedback", icon: "MessageSquare" },
    { label: "Security", href: "/admin/security", icon: "Shield" },
    { label: "Verifications", href: "/admin/verifications", icon: "ShieldCheck" },
    { label: "Partner Applications", href: "/admin/partner-apps", icon: "Briefcase" },
    { label: "Risk", href: "/admin/risk", icon: "AlertTriangle" },
    { label: "Incidents", href: "/admin/incidents", icon: "AlertOctagon" },
    { label: "Integrity", href: "/admin/integrity", icon: "Database" },
    { label: "API Management", href: "/admin/api", icon: "Key" },
    { label: "Status Publisher", href: "/admin/public-status", icon: "FileText" },
    { label: "Audit Logs", href: "/admin/audits", icon: "ClipboardCheck" },
    { label: "Exports & Reports", href: "/admin/exports", icon: "FileText" },
    { label: "Data Governance", href: "/admin/policies", icon: "FileText" },
  ],
} as const;

export const FOOTER_LINKS = {
  product: [
    { label: "How it works", href: "/how-it-works" },
    { label: "For Individuals", href: "/individuals" },
    { label: "For Institutions", href: "/institutions" },
    { label: "Pricing", href: "/pricing" },
  ],
  company: [
    { label: "About", href: "/about" },
    { label: "Trust Center", href: "/trust" },
    { label: "Status", href: "/status" },
    { label: "Insights", href: "/insights" },
  ],
  legal: [
    { label: "Privacy", href: "/privacy" },
    { label: "Terms", href: "/terms" },
    { label: "Cookies", href: "/cookies" },
    { label: "AI Statement", href: "/ai-statement" },
  ],
} as const;
